import { useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'

import { usePSNavigate } from '../../../hooks/usePSNavigate'
import { SelectPlanPage } from '../../settings/SelectPlanPage'

export function AlertTeamPage() {
    const queryClient = useQueryClient()
    const navigate = usePSNavigate()

    const onNext = useCallback(async () => {
        await queryClient.invalidateQueries({ queryKey: ['dashboard'] })
        navigate('/')
    }, [navigate, queryClient])

    return (
        <SelectPlanPage
            context="team"
            onBack={{ label: 'Home', href: '/' }}
            onNext={onNext}
            isInWorkflow
        />
    )
}
